import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { UserService } from "../shared/services";


@Component({
  selector: "app-sandbox-interceptor",
  templateUrl: "./sandbox-interceptor.component.html",
  styleUrls: ["./sandbox-interceptor.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class SandBoxInterceptorComponent implements OnInit {

  constructor(public router: Router,private _us:UserService) {
  }

  ngOnInit() {
    if (localStorage.getItem('_up')) {
      let res = localStorage.getItem("_up");
      localStorage.setItem("sdsxc", btoa(res));
      this._us.settingOperation();
    }
    setTimeout(() => {
      this.router.navigateByUrl('sandbox');
    }, 1000);
  }
}




// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/sandbox-interceptor/sandbox-interceptor.component.ts